import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import {Icon} from '@iconify/vue'
import * as ElIcons from '@element-plus/icons-vue'
// const baseSize = 50
// // 设置 rem 函数
// function setRem () {
//   // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
//   const scale = document.documentElement.clientWidth / 750
//   // 设置页面根节点字体大小
//   document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
// }
// 初始化
// setRem()
// 改变窗口大小时重新设置 rem
// window.onresize = function () {
//   setRem()
// }
const app = createApp(App)
for (const [key, component] of Object.entries(ElIcons)) {
  app.component(key, component)
}
app.component('iconify',Icon).use(store).use(router).use(ElementPlus, { size: 'small', zIndex: 3000 }).mount('#app')
